export const REFRESH_INTERVAL = 5000;

export const COLORS = {
	outOfRange: "#E60000",
	standInactive: "#D6D4D4",
	standNoBarrel: "#F7A2A2",
} as const;

export const CELL_HEIGHT = 25;
export const CELL_FONT_SIZE = 11;
